export default [
  {
    path: "/meeting/online-meeting",
    name: "online-meeting",
    meta: { auth: true, title: "Online-Meeting" },
    component: () => import("../views/meeting/online-meeting.vue")
  },
  {
    path: '/meeting/meeting-statistics',
    name: 'meeting-statistics',
    meta: { title: 'Meeting-Statistics' },
    component: () => import("../views/meeting/meeting-statistics.vue")
  },
]